import { PRIVILEGES } from '../api/types/dtos';

export type NavItemCategory =
  | 'core'
  | 'inspections'
  | 'training'
  | 'analytics'
  | 'reports'
  | 'admin'
  | 'tools';

export interface NavItem {
  path: string;
  label: string;
  iconKey: string;
  privilege?: string;
  dynamicProperty?: string;
  category: NavItemCategory;
}

export interface NavGroup {
  label: string;
  iconKey: string;
  children: NavItem[];
}

export type NavEntry = NavItem | NavGroup;

function isGroup(entry: NavEntry): entry is NavGroup {
  return 'children' in entry;
}

export { isGroup };

export const NAV_ENTRIES: NavEntry[] = [
  {
    path: '/organizations/search',
    label: 'Organizaciones',
    iconKey: 'directory',
    privilege: PRIVILEGES.READ_ORGANIZATION,
    category: 'core',
  },
  {
    path: '/analytics/dashboards',
    label: 'Analiticas',
    iconKey: 'analytics',
    privilege: PRIVILEGES.READ_ANALYTICS,
    category: 'analytics',
  },
  {
    path: '/trainings/progress',
    label: 'Progreso de Capacitaciones',
    iconKey: 'trainingsProgress',
    privilege: PRIVILEGES.READ_TRAINING_CONTENT_PROGRESS,
    dynamicProperty: 'section_trainings',
    category: 'training',
  },
  {
    label: 'Gestion',
    iconKey: 'trainingsManagement',
    children: [
      {
        path: '/trainings/manage',
        label: 'Gestion de Capacitaciones',
        iconKey: 'trainingsManagement',
        privilege: PRIVILEGES.CREATE_TRAINING,
        dynamicProperty: 'section_trainings',
        category: 'training',
      },
      {
        path: '/challenges/manage',
        label: 'Gestionar Retos',
        iconKey: 'challengesManage',
        privilege: PRIVILEGES.CREATE_INSPECTION,
        dynamicProperty: 'section_inspections',
        category: 'inspections',
      },
      {
        path: '/challenges/report-builder',
        label: 'Constructor de Reportes',
        iconKey: 'reportBuilder',
        privilege: PRIVILEGES.CREATE_REPORT_TEMPLATE,
        category: 'reports',
      },
      {
        path: '/programs/manage',
        label: 'Gestion de Programas',
        iconKey: 'programs',
        privilege: PRIVILEGES.CREATE_PROGRAMS_VERSION,
        category: 'admin',
      },
    ],
  },
  {
    path: '/challenges',
    label: 'Retos',
    iconKey: 'challenges',
    privilege: PRIVILEGES.CREATE_INSPECTION,
    dynamicProperty: 'section_inspections',
    category: 'inspections',
  },
  {
    label: 'Reportes y Sync',
    iconKey: 'reportsSync',
    children: [
      {
        path: '/reports',
        label: 'Reportes',
        iconKey: 'reports',
        privilege: PRIVILEGES.READ_REPORT,
        category: 'reports',
      },
      {
        path: '/sync-configs',
        label: 'Sincronizacion',
        iconKey: 'sync',
        privilege: PRIVILEGES.CREATE_SYNC_CONFIG,
        category: 'admin',
      },
    ],
  },
  {
    path: '/user-uploader',
    label: 'Carga de Usuarios',
    iconKey: 'userUploader',
    privilege: PRIVILEGES.CREATE_ORGANIZATION,
    category: 'tools',
  },
  {
    label: 'Carga de Logos',
    iconKey: 'logoUploader',
    children: [
      {
        path: '/logo-uploader',
        label: 'Carga de Logos',
        iconKey: 'logoUploader',
        privilege: PRIVILEGES.UPDATE_ORGANIZATION,
        category: 'tools',
      },
      {
        path: '/logos-from-map',
        label: 'Logos desde Mapa',
        iconKey: 'logosFromMap',
        privilege: PRIVILEGES.UPDATE_ORGANIZATION,
        category: 'tools',
      },
    ],
  },
  {
    path: '/activity-log',
    label: 'Registro de Actividad',
    iconKey: 'activityLog',
    privilege: PRIVILEGES.READ_ACTIVITY_FEED,
    category: 'admin',
  },
];

